/* Issue #52: mobile color pill on product cards (<750px).
   First tap on the collapsed pill expands it in place; taps on chips then select normally
   (the theme swaps the card image); tapping outside collapses. Desktop uses CSS hover only. */
(function () {
  if (window.__gsCardColorPill) return;
  window.__gsCardColorPill = true;

  var BAND = '.product-card__options--band';
  var mobile = window.matchMedia('(max-width: 749px)');

  function closeAll(except) {
    var open = document.querySelectorAll(BAND + '.is-open');
    for (var i = 0; i < open.length; i += 1) {
      if (open[i] !== except) open[i].classList.remove('is-open');
    }
  }

  document.addEventListener('click', function (event) {
    if (!mobile.matches) return;
    var band = event.target.closest ? event.target.closest(BAND) : null;
    if (!band) {
      closeAll(null);
      return;
    }
    if (!band.classList.contains('is-open')) {
      event.preventDefault();
      closeAll(band);
      band.classList.add('is-open');
    }
  });

  mobile.addEventListener('change', function () { closeAll(null); });
})();
